import { render, staticRenderFns } from "./Specimen.vue?vue&type=template&id=22163160&scoped=true&"
import script from "./Specimen.vue?vue&type=script&lang=js&"
export * from "./Specimen.vue?vue&type=script&lang=js&"
import style0 from "./Specimen.vue?vue&type=style&index=0&id=22163160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22163160",
  null
  
)

export default component.exports